<p class="mt-3 mr-0 mb-0 ml-3">Você está sendo redirecionado,</p>
<p class="mt-0 mr-0 mb-0 ml-3">caso isso não aconteça <a [href]="playlistUrl">clique aqui</a>!</p>